import {gql} from "@apollo/client";

const LISTING_LIST = gql`
    query L ($keywords: String, $listingType: String, $categories: [ID], $tags: [ID], $limit: Int, $offset: Int){
        listings (keywords: $keywords, listingType: $listingType, categories: $categories, tags: $tags, limit: $limit, offset: $offset ) {
            edges {
                node {
                    Identifier
                    Title
                    Type
                    URLSegment
                    ThirdpartyURL
                    Website
                    Featured
                    CustomTileDescription
                    CustomLinkListingDirectlyToExternalLink
                    FullAddressHTML
                    Summary
                    MainImage {
                        Title
                        AbsoluteURL
                        Loading
                        Sized(width: 320, height: 240)
                    }
                }
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                totalCount
            }
        }
    }
`

export default LISTING_LIST;
